export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  // {
  //   field: 'col-opt',
  //   title: that.$l('INDEX.table_label_operation') || '操作',
  //   headerAlign: 'center',
  //   align: 'center',
  //   fixed: 'right',
  //   width: 80,
  //   showHeaderOverflow: true,
  //   slots: { default: 'opt' },
  // },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'displayImage',
    align: 'center',
    width: 120,
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_fabirc_info') || '面料信息',
    field: 'fabircInfo',
    minWidth: 155,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabircInfo' },
  },
  {
    title: that.$l('table_label_fabirc_color') || '面料颜色',
    field: 'fabircColor',
    minWidth: 90,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabircColor' },
  },
  {
    title: that.$l('table_label_fabirc_content') || '面料成分',
    field: 'fabircContent',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabircContent' },
  },
  {
    title: that.$l('table_label_fabirc_product_color') || '适用产品颜色',
    field: 'fabircProductColor',
    minWidth: 90,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabircProductColor' },
  },
  {
    title: that.$l('table_label_fabirc_desc') || '具体说明',
    field: 'notes',
    minWidth: 220,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fabirc_scm') || '供应商',
    field: 'fabircScm',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabircScm' },
  }
]
